import React from "react";
import axios from 'axios';
import '../BillPayComponent/billPayy.css';
import $, { timers } from "jquery";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import FooterComponet from "../FooterComponent/FooterComponet";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import './merchantpayout.css';
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";
import '../RechargeComponent/txnhistory.css';
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
import { setAmount, setCreateOrderRes, setCreteOrderReq, setMerchantDetails, setMoneyTransferSurChargeAmount, setMoneyTransferTotalAmount, setOrderId, showCreateOrderResponse } from "../../redux/payout/payout.action";
import { setIfscCode, setSelectedBankName } from "../../redux/misc-data/misc-data.action";

const httpClient = axios.create();
class Merchant extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: '',
            enableMerchantPayout: false,
            merchantDetails: '',
            retailerBalance: '',
            amount: '',
            redirectToImageUpload: false,
            redirectToAddAccountPage: false,
            orderErrMsg: '',
            amountErrMsg: '',
            merchantLoading: '',
            loadedBalance: ''
        }
    }





    componentDidMount() {
        store.dispatch(setSelectedBankName(''));
        store.dispatch(setIfscCode(''));
        if (this.props.agentInfo.status == 'BANK_KYC_COMPLETE') {
            this.getMerchantDetails();
            this.getPayoutAvailableBalance();
        }

    }
    componentWillUnmount() {
    }

    enterAmount = (event) => {
        this.setState({
            amount: event.target.value
        })
    }



    validationWithRegex(value, regex) {
        console.log('validationWithRegex value=' + value + ';regex=' + regex);
        if (regex != null && regex != undefined && regex != '') {
            var re = new RegExp(regex);
            if (!re.test(value)) {

                return false;
            }
            else {

                return true;
            }
        } else {
            return true;
        }

    }

    getPayoutAvailableBalance = () => {
        this.setState({
            orderErrMsg: '',
            loadedBalance: 'false'
        })
        var url = '/api/v1/account/balance/';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(url + this.props.agentInfo.id, { headers }
        ).then((response) => {
            var retailerBalanceVal = response.data.balance + response.data.creditLimit -
                response.data.lien;
            this.setState({
                retailerBalance: retailerBalanceVal,
                loadedBalance: 'true'
            })

        }).catch(error => {


            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else {
                this.setState({
                    orderErrMsg: 'Error in fetching balance'
                })
            }

            console.log(error.message);
        });
    }


    calculatePricingValidation = () => {
        if (this.state.amount != null &&
            this.state.amount != '' &&
            this.state.amount > 0) {
            return true;
        } else {
            return false;
        }
    }

    calculatePricing = (event) => {



        event.preventDefault();
        this.setState({
            amountErrMsg: ''
        })

        var calculatePricingValidationVal = this.calculatePricingValidation();

        if (calculatePricingValidationVal == true) {

            this.setState({
                progess: 'loading',
                displayErrorMsg: '',
                orderErrMsg: ''
            })
            store.dispatch(setMoneyTransferTotalAmount(''));
            store.dispatch(setMoneyTransferSurChargeAmount(''));
            store.dispatch(showCreateOrderResponse(''));
            store.dispatch(setOrderId(''));
            store.dispatch(setAmount(''));

            const header = {
                msgType: "CALCULATE_PRICING",
                service: "PRICING",
                channel: "ADMIN",
                requesterId: this.props.clientRequesterId,
                requestId: uuidv4(),//filled by the 3rd party requester
                time: moment().utc(),
                traceId: uuidv4(),
            }

            var pricingUrl = '/api/v1/pricing/calculate';

            const pricingReq = {
                header: header,
                entityId: this.props.agentInfo.id,
                entityType: "RETAILER",//ROLE_RETAILER
                productTree:
                {
                    serviceCode: "BANKING",
                    categoryCode: 'PAYOUT',//temp value
                    productCode: "PAYSPRINT"// will be changed
                },
                txnAmount: parseFloat(this.state.amount).toFixed(2)
            }
            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }

            console.log('pricing req:' + JSON.stringify(pricingReq));


            httpClient.post(pricingUrl, pricingReq, {
                timeout: 60 * 1000,
                timeoutErrorMessage: 'timeout',
                headers
            }
            ).then((response) => {
                this.setState({
                    progress: 'completed',
                    progressStatus: false,
                    calculatePricingFiledLock: true

                })
                console.log('pricing response msg' + JSON.stringify(response.data.response.msg));
                if (response.data.response.msg == 'SUCCESS') {

                    console.log('pricing service response:' + JSON.stringify(response.data))

                    var totalAmount = parseInt(response.data.txnAmount) +
                        parseInt(response.data.pricingAmount);
                    store.dispatch(setMoneyTransferTotalAmount(totalAmount));
                    store.dispatch(setMoneyTransferSurChargeAmount(response.data.pricingAmount));
                    store.dispatch(showCreateOrderResponse(response.data));
                    store.dispatch(setOrderId(response.data.pricingId));
                    store.dispatch(setMoneyTransferTotalAmount(totalAmount));
                    store.dispatch(setAmount(parseFloat(this.state.amount).toFixed(2)));
                    store.dispatch(setMerchantDetails(this.state.merchantDetails));

                    var payoutReview = document.getElementById('payoutReview');
                    payoutReview.click();

                } else {
                    this.setState({
                        orderErrMsg: response.data.response.displayMsg
                    })
                }
            }).catch(error => {
                this.setState({
                    progress: 'completed',
                    progressStatus: false,
                    orderErrMsg: 'Something went wrong!'
                })

                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else if (error.message.includes("timeout")) {
                    this.setState({
                        orderErrMsg: 'Request timed out.'
                    })

                } else {
                    this.setState({
                        orderErrMsg: 'pricing failed-' + error.message
                    })
                }


            })
        } else {
            this.setState({
                amountErrMsg: 'Please enter amount'
            })
        }
    }

    getMerchantDetails() {
        this.setState({
            orderErrMsg: '',
            merchantLoading: 'started'
        })
        var url = '/api/v1/payout/connector/get-merchant-details/'
            + this.props.agentInfo.id;

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        httpClient.get(url, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            this.setState({
                merchantLoading: 'completed'
            })

            console.log(' get merchant details response' + JSON.stringify(response.data));

            if (response.data.response.msg == 'SUCCESS') {

                var tpsRspMsg = response.data.response.tpsRspMsg.toLowerCase();
                if (tpsRspMsg.includes("please upload")) {

                    this.setState({
                        redirectToImageUpload: true,
                        enableMerchantPayout: false,
                        merchantDetails: response.data,
                        redirectToAddAccountPage: false
                    })

                } else if (tpsRspMsg.includes("unable to add account")) {
                    this.setState({
                        orderErrMsg: response.data.response.tpsRspMsg.replace("displayMsg:", ""),
                        enableMerchantPayout: false,
                        redirectToAddAccountPage: true,
                        redirectToImageUpload: false

                    })
                } else if (response.data.beneficiary.verified == true &&
                    response.data.beneficiary.active == true) {
                    this.setState({
                        enableMerchantPayout: true,
                        merchantDetails: response.data,
                        redirectToImageUpload: false,
                        redirectToAddAccountPage: false

                    })

                }
                else if ((response.data.beneficiary.verified == false ||
                    response.data.beneficiary.verified == null) &&
                    response.data.beneficiary.active == true) {
                    this.setState({
                        enableMerchantPayout: false,
                        merchantDetails: response.data,
                        redirectToImageUpload: true,
                        redirectToAddAccountPage: false


                    })
                }
                else if ((response.data.beneficiary.verified == false ||
                    response.data.beneficiary.verified == null) &&
                    (response.data.beneficiary.active == false
                        || response.data.beneficiary.active == null)) {
                    this.setState({
                        enableMerchantPayout: false,
                        merchantDetails: response.data,
                        redirectToImageUpload: false,
                        redirectToAddAccountPage: true

                    })
                } else {
                    this.setState({
                        orderErrMsg: response.data.response.tpsRspMsg.replace("displayMsg:", "")
                    })
                }


                if (process.env.REACT_APP_PAYOUTACCOUNTSTATUS == 'yes') {
                    var createdBeneId = response.data.beneficiary.createdBeneId;
                    // this.callAccountStatusCheck(createdBeneId, this.props.agentInfo.id);


                    if (createdBeneId == null || createdBeneId == "" || createdBeneId == undefined) {
                        createdBeneId = response.data.beneficiary.id;
                        if (createdBeneId != null && createdBeneId != "" && createdBeneId != undefined) {
                            if (response.data.beneficiary.verified == false ||
                                response.data.beneficiary.active == false ||
                                (response.data.beneficiary.verified == false &&
                                    response.data.beneficiary.active == false)
                            ) {
                                this.callAccountStatusCheck(createdBeneId, this.props.agentInfo.id);
                            }

                        }
                    } else {
                        if (response.data.beneficiary.verified == false ||
                            response.data.beneficiary.active == false ||
                            (response.data.beneficiary.verified == false &&
                                response.data.beneficiary.active == false)
                        ) {
                            this.callAccountStatusCheck(createdBeneId, this.props.agentInfo.id);
                        }
                    }
                }




            } else {
                console.log('calling add account API');
                this.setState({
                    redirectToAddAccountPage: true
                })
            }
        }).catch(error => {
            this.setState({
                merchantLoading: 'completed'
            })

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else if (error.message.includes("timeout")) {
                this.setState({
                    orderErrMsg: 'Request timed out'
                })
            } else {
                this.setState({
                    orderErrMsg: 'Error in fetching merchant details'
                })
            }
        })
    }

    callAccountStatusCheck(createdBeneId, agentId) {

        this.setState({
            addAccountStatus: ''
        })

        var url = '/api/v1/payout/connector/accountStatus/' + createdBeneId + '/' + agentId;

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        
        httpClient.get(url, {
            timeout: 60 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {

            console.log(' account status check response : ' + JSON.stringify(response.data));

            if (response.data != undefined) {
                if (response.data.response != undefined) {
                    if (response.data.response.msg != undefined) {

                        if (response.data.response.msg == 'SUCCESS') {
                            this.setState({
                                enableMerchantPayout: true,
                                // merchantDetails: response.data,
                                redirectToImageUpload: false,
                                redirectToAddAccountPage: false

                            })
                        }
                        if (response.data.response.msg == 'FAIL') {
                            if (response.data.optional.response_code.includes("0")||
                            response.data.optional.response_code.includes("NA")) {
                                if (response.data.optional.response_code.includes("NA")) {
                                    this.setState({
                                        addAccountStatus: ""
                                    })
                                }
                                if(response.data.optional.response_code.includes("0")){
                                    this.setState({
                                        enableMerchantPayout: false,
                                        // merchantDetails: response.data,
                                        redirectToImageUpload: false,
                                        redirectToAddAccountPage: true,
                                        addAccountStatus: 'Last added Account deactivated.Please add another account'
                                    })
                                }
                                if (response.data.response.tpsRspMsg.toLowerCase().includes("deactivated")) {
                                    this.setState({
                                        enableMerchantPayout: false,
                                        // merchantDetails: response.data,
                                        redirectToImageUpload: false,
                                        redirectToAddAccountPage: true,
                                        addAccountStatus: 'Last added Account deactivated.Please add another account'
                                    })
                                }
                                if (response.data.response.tpsRspMsg.toLowerCase().includes("not found")) {
                                    this.setState({
                                        enableMerchantPayout: false,
                                        // merchantDetails: response.data,
                                        redirectToImageUpload: false,
                                        redirectToAddAccountPage: true,
                                    })
                                }
                            }
                            if (response.data.optional.response_code.includes("3")) {
                                this.setState({
                                    // enableMerchantPayout: false,
                                    // // merchantDetails: response.data,
                                    // redirectToImageUpload: false,
                                    // redirectToAddAccountPage: false,
                                    addAccountStatus: 'Last added Document under verification'

                                })
                            }

                        }
                        if (response.data.response.msg == 'PENDING') {
                            this.setState({
                                enableMerchantPayout: false,
                                // merchantDetails: response.data,
                                redirectToImageUpload: true,
                                redirectToAddAccountPage: false,
                                addAccountStatus: ''

                            })
                        }
                    }
                }
            }


        }).catch(error => {
            console.log(error.message);

        })
    }


    redirectToImageUploadPage = (event) => {
        event.preventDefault();
        var accountImageUpload = document.getElementById('accountImageUpload');
        accountImageUpload.click();

    }


    redirectToMerchabtOnboardPage = (event) => {
        event.preventDefault();
        var redirectToMerchabtOnboard = document.getElementById('redirectToMerchabtOnboard');
        redirectToMerchabtOnboard.click();

    }

    redirectToAddAccountPageAction = (event) => {
        event.preventDefault();
        var gotoAddAccountPage = document.getElementById('gotoAddAccountPage');
        gotoAddAccountPage.click();

    }

    render() {
        return (
            <div>
                <HeadeCommon />
                <Menu />
                <div class="main">
                    <Link to='/add-account'>
                        <button id="gotoAddAccountPage" hidden={true}></button>
                    </Link>
                    <Link to='/doc-upload'>
                        <button id="accountImageUpload" hidden={true}></button>
                    </Link>
                    <Link to='/merchant-onboard'>
                        <button id="redirectToMerchabtOnboard" hidden={true}></button>
                    </Link>
                    <Link to='/payout-transfer'>
                        <button id="payoutTransferDetails" hidden={true}></button>
                    </Link>
                    <Link to='/payout-review'>
                        <button id="payoutReview" hidden={true}></button>
                    </Link>
                    {this.props.agentInfo.status == 'BANK_KYC_COMPLETE' &&

                        <div class="container-fluid">
                            <div class="head">
                                <h3>Merchant Payout</h3>
                                <div id="recenttxn">
                                    <Link to='/payout-txn'>
                                        <button type="button">View History</button>
                                    </Link>
                                </div>

                            </div>
                            <div class="usercard">
                                <div class="row">
                                    <div class="col-12 col-md-6 col-lg-4">


                                        <div class="merchant-dtls">
                                            {/* <img src="images/merchant.png" alt="Merchant" class="img-fluid"/> */}
                                            <h6>{this.props.agentInfo.kioskName.toUpperCase()}</h6>
                                            <p>RO ID: <strong>
                                                {this.props.agentInfo.id}
                                            </strong></p>
                                        </div>



                                        <div class="merchant-other-dtls">




                                            <p>Mobile Number:</p>
                                            <h6>{this.props.agentInfo.mobile
                                            }</h6>



                                            <p>Company Email ID:</p>
                                            <h6>{(this.props.agentInfo.email != '' &&
                                                this.props.agentInfo.email != null) ?
                                                this.props.agentInfo.email :
                                                "NA"
                                            }</h6>

                                            <p>Account Number:</p>
                                            <h6>{(this.state.merchantDetails != '' &&
                                                this.state.merchantDetails.beneficiary.bankAccNo != null &&
                                                this.state.merchantDetails.beneficiary.bankAccNo != '') ?
                                                this.state.merchantDetails.beneficiary.bankAccNo :
                                                "NA"
                                            }</h6>




                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6 col-lg-8">
                                        <div class="merchant-right">
                                            <div class="merchant-bank">
                                                <h4>Merchant  Bank Account Details</h4>


                                                <div class="merchant-bank-dtls">
                                                    <div class="merchant-bank-name">
                                                        <img src="images/bank-logo.png" alt="Bank " class="img-fluid" />
                                                        <h5>{(this.state.merchantDetails != '' &&
                                                            this.state.merchantDetails.beneficiary.beneName != null &&
                                                            this.state.merchantDetails.beneficiary.beneName != '') ?
                                                            this.state.merchantDetails.beneficiary.beneName.toUpperCase() :
                                                            "NA"
                                                        }</h5>
                                                        <p>Ac No.: {(this.state.merchantDetails != '' &&
                                                            this.state.merchantDetails.beneficiary.bankAccNo != null &&
                                                            this.state.merchantDetails.beneficiary.bankAccNo != '') ?
                                                            this.state.merchantDetails.beneficiary.bankAccNo :
                                                            "NA"
                                                        }</p>
                                                    </div>
                                                    <div class="dropdown-divider"></div>
                                                    <div class="merchant-bank-name">
                                                        <h6>{(this.state.merchantDetails != '' &&
                                                            this.state.merchantDetails.beneficiary.bankName != null &&
                                                            this.state.merchantDetails.beneficiary.bankName != '') ?
                                                            this.state.merchantDetails.beneficiary.bankName :
                                                            "NA"
                                                        }</h6>
                                                        <p>IFSC code: {(this.state.merchantDetails != '' &&
                                                            this.state.merchantDetails.beneficiary.ifscCode != null &&
                                                            this.state.merchantDetails.beneficiary.ifscCode != '') ?
                                                            this.state.merchantDetails.beneficiary.ifscCode :
                                                            "NA"
                                                        }</p>
                                                    </div>
                                                </div>

                                                {this.state.loadedBalance == 'true' &&

                                                    <div class="payout-blc">
                                                        <i class="ta"></i>
                                                        <p>Payout Available Balance:</p>
                                                        <h5>₹{this.state.retailerBalance}</h5>
                                                    </div>
                                                }

                                                {this.state.addAccountStatus != "" &&
                                                    this.state.addAccountStatus != undefined &&
                                                    this.state.addAccountStatus != null &&
                                                    <div class="valid-error">
                                                        {this.state.addAccountStatus}
                                                    </div>
                                                }

                                                <div class="payout-form">
                                                    <div class="row">

                                                        {this.state.redirectToImageUpload == true &&
                                                            <div class="col-12 mt-4">


                                                                <div>
                                                                    <button type="button" id="aepsbtn" class="btn btn-primary"
                                                                        onClick={this.redirectToImageUploadPage}>Upload Docs</button>
                                                                </div>
                                                            </div>


                                                        }


                                                        {this.state.redirectToAddAccountPage == true &&
                                                            <div class="col-12 mt-4">


                                                                <div>
                                                                    <button type="button" id="aepsbtn" class="btn btn-primary"
                                                                        onClick={this.redirectToAddAccountPageAction}>Add  Account</button>
                                                                </div>
                                                            </div>
                                                        }
                                                        {this.state.enableMerchantPayout == true &&
                                                            <div>
                                                                <form onSubmit={this.calculatePricing}>
                                                                    <div class="col-12 col-md-5">

                                                                        <div class="formrow">
                                                                            <div class="form-floating">
                                                                                <input type="text" class="form-control" id="amt" placeholder="amount"
                                                                                    readOnly={this.state.enableMerchantPayout == false && true}
                                                                                    onChange={this.enterAmount}
                                                                                    value={this.state.amount} />

                                                                                <label for="amt">Enter payout amount</label>
                                                                                {this.state.amountErrMsg != '' &&
                                                                                    <div class='valid-error'>
                                                                                        {this.state.amountErrMsg}
                                                                                    </div>


                                                                                }
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                    <div class="col-12 col-md-5">
                                                                        <button class="btn btn-primary " type="submit"
                                                                            disabled={this.state.progress == 'loading' && true}>Proceed</button>



                                                                    </div>

                                                                </form>

                                                            </div>

                                                        }
                                                        {this.state.orderErrMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.orderErrMsg}</div>}

                                                        {this.state.merchantLoading == 'started' &&
                                                            <div class='valid-success'>
                                                                Loading..</div>}

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    }
                    {this.props.agentInfo.status != 'BANK_KYC_COMPLETE' &&


                        <div class="container-fluid">
                            <div class="card-b" id="rightdiv">
                                <div class="head">

                                    <h3>Merchant Payout</h3>

                                </div>
                                <div class='valid-success'>
                                    Please onboard before Merchant Payout
                                </div>
                                <button type="button" id="aepsbtn" class="lbbtn"
                                    onClick={this.redirectToMerchabtOnboardPage}>Merchant Onboard</button>

                            </div>
                        </div>
                    }
                </div>
                <FooterComponet />
            </div>




        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, moneyTransferResponseDetails, createOrderResponseDetails,
            agentInfo, token, clientRole, clientRequesterId, selectSender, benefisciaryInfo, surcharge,
            transferTotalAmount, deviceInfo, customerLimit,
            customerId, bankLogoListTxt, billerData, paremeterData,
            callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, moneyTransferResponseDetails,
    createOrderResponseDetails, agentInfo, token, clientRole, clientRequesterId, selectSender, benefisciaryInfo, surcharge,
    transferTotalAmount, deviceInfo, customerLimit,
    customerId, bankLogoListTxt, billerData, paremeterData,
    callBackUrl
});

export default connect(mapStateToProps, null)(Merchant);

